import { Component, OnInit } from '@angular/core';
import { AddChampProduitCrmComponent } from './add-champ-produit-crm/add-champ-produit-crm.component';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChampSourceProduitCrm } from '../../core/model/produitCrm/ChampSourceProduitCrm';
import { ProduitCrmService } from '../../core/service/produit-crm.service';

@Component({
  selector: "app-champ-produit-crm",
  templateUrl: "./champ-produit-crm.component.html",
  styleUrls: ["./champ-produit-crm.component.scss"]
})
export class ChampProduitCrmComponent implements OnInit {
  champSourceProduitCrm: ChampSourceProduitCrm[];

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _produitCrmService: ProduitCrmService
  ) {}

  ngOnInit() {
    this.getChampSourceGaranties();
  }

  getChampSourceGaranties() {
    this._produitCrmService.getChampSourceProduitCrm().subscribe(data => {
      this.champSourceProduitCrm = data;
    });
  }

  deleteDetail(group: ChampSourceProduitCrm) {}

  editDetail(champSourceProduitCrm: ChampSourceProduitCrm) {
    const modalRef = this.modalService.open(AddChampProduitCrmComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "my-app-app-modal-class"
    });

    modalRef.componentInstance.champSourceProduitCrm = champSourceProduitCrm;
    modalRef.result.then(
      result => {
        console.log("result", result);
        // on close
        this.getChampSourceGaranties();
      },
      reason => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  addChampSourceProduitCrm() {
    const modalRef = this.modalService.open(AddChampProduitCrmComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "type-document-garantie-modal"
    });
    //modalRef.componentInstance.profile = this.profile;
    modalRef.result.then(
      result => {
        console.log("result", result);
        // on close
        this.getChampSourceGaranties();
      },
      reason => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }
}
